<template>
    <div class="container">
        <h2 class="profile-page-title">
            <span @click="currentTabIndex = 0"
                  :class="['ref-order-tab', 'ml-3', {'active': currentTabIndex === 0}]">{{ $t('success_orders') }}</span>
            <span class="profile-page-title__count ml-1">({{ orders.length }})</span>
            <span @click="currentTabIndex = 1"
                  :class="['ref-order-tab', 'ml-3', {'active': currentTabIndex === 1}]">{{ $t('unsuccess_orders') }}</span>
            <span class="profile-page-title__count ml-1">({{ failedOrders.length }})</span>
            <span @click="currentTabIndex = 2"
                  :class="['ref-order-tab', 'ml-3', {'active': currentTabIndex === 2}]">{{ $t('payed_orders') }}</span>
            <span class="profile-page-title__count ml-1">({{ payedOrders.length }})</span>
            <span @click="currentTabIndex = 3"
                  :class="['ref-order-tab', 'ml-3', {'active': currentTabIndex === 3}]">{{ $t('information') }}</span>
        </h2>

        <div class="row">
            <div class="col-12 col-lg-5">
                <h3>Фильтр по датам:</h3>
                <button type="button" class="btn btn-secondary btn-sm" @click="setAll">{{ $t('all') }}</button>
                <button type="button" class="btn btn-secondary btn-sm" @click="setCurrentMonth">{{ $t('this_month') }}</button>
                <button type="button" class="btn btn-secondary btn-sm" @click="setPrevMonth">{{ $t('last_month') }}</button>
                <button type="button" class="btn btn-secondary btn-sm" @click="setPrev30days">{{ $t('last_30_days') }}</button>
            </div>
            <div class="col-12 col-lg-3">
                <base-date-picker alternative=""
                                  :label="$t('begin_date')"
                                  :placeholder="$t('enter_begin_date')"
                                  input-classes="form-control-alte rnative"
                                  format="YYYY-MM-DD"
                                  v-model="fromDate"

                />
            </div>
            <div class="col-12 col-lg-3">
                <base-date-picker alternative=""
                                  :label="$t('end_date')"
                                  :placeholder="$t('enter_end_date')"
                                  input-classes="form-control-alternative"
                                  format="YYYY-MM-DD"
                                  v-model="toDate"

                />
            </div>
        </div>

        <div class="row">
            <div class="col-12 pb-6" v-if="currentTabIndex === 0">
                <div class="row justify-content-center">
                    <ref-orders
                            :orders="ordersFiltered"/>
                </div>
            </div>
            <div class="col-12 pb-6" v-if="currentTabIndex === 1">
                <div class="row justify-content-center">
                    <ref-failed
                            :orders="failedOrdersFiltered"/>
                </div>
            </div>
            <div class="col-12 pb-6" v-if="currentTabIndex === 2">
                <div class="row justify-content-center">
                    <ref-payed
                            :orders="payedOrdersFiltered"/>
                </div>
            </div>
            <div class="col-12 pb-6" v-if="currentTabIndex === 3">
                <p class="mt-2">Реферальная программа партнера Полиглотики HomeTeacher™ – это способ онлайн-продаж образовательных
                    курсов клиентам и привлечения новых потребителей на образовательную Онлайн-Платформу Полиглотики
                    poliglotiki.com.</p>
                <h2>Как выглядит ваша Реферальная ссылка?</h2>

                <p>Ваш ID партнера: <span class="strong-black">{{ user.ref_id }}</span></p>
                <p>Чтобы засчитался реферальный переход, все ссылки для Партнера должны содержать GET параметр: <span
                        class="strong-black">?i={{ user.ref_id }}</span></p>
                <p>Примеры Реферальных ссылок с обозначенным ID Партнера:</p>
                <ul>
                    <li><span class="strong-black">https://poliglotiki.com/home-teacher/godovoj-kurs-anglijskogo-yazyka?i={{ user.ref_id }}</span>
                        - годовой курс английского.
                    </li>
                    <li><span class="strong-black">https://poliglotiki.com/home-teacher/godovoj-kurs-anglijskij-s-rozhdeniya?i={{ user.ref_id }}</span>
                        - годовой курс "Английский с рождения".
                    </li>
                    <li><span class="strong-black">https://poliglotiki.com/home-teacher/godovoj-kurs-ispanskogo-yazyka?i={{ user.ref_id }}</span>
                        - годовой курс испанского.
                    </li>
                    <li><span class="strong-black">https://poliglotiki.com/home-teacher/godovoj-kurs-skorochteniya?i={{ user.ref_id }}</span>-
                        годовой курс скорочтения.
                    </li>
                    <li><span
                            class="strong-black">https://poliglotiki.com/home-teacher/courses?i={{ user.ref_id }}</span>
                        - страница со списком курсов.
                    </li>
                    <li><span class="strong-black">https://poliglotiki.com/home-teacher/course/on-vacation/details?i={{ user.ref_id }}</span>
                        - страница с описанием курса.
                    </li>
                    <li><span class="strong-black">https://poliglotiki.com/home-teacher/courses?lang=1&age=1&i={{ user.ref_id }}</span>
                        - страница со списком английских курсов для дошкольников.
                    </li>
                </ul>

                <p> Партнер самостоятельно формирует Реферальную ссылку на необходимую страницу сайта с конкретным
                    продуктом. Поддержка и помощь в регистрации и создании ссылок от Администрации Платформы по email:
                    <a href="mailto:care@poliglotiki.ru" target="_blank">care@poliglotiki.ru</a>.</p>

                <p class="pt-4">Подробное <a href="https://www.poliglotiki.ru/admin/document/194?preview=1"
                                             target="_blank">описание условий партнерской программы</a>.</p>

            </div>
        </div>

    </div>
</template>

<script>

    import RefOrders from "../../Referal/RefOrders";
    import userApi from "../../../data/UserApi";
    import RefFailed from "../../Referal/RefFailed";
    import RefPayed from "../../Referal/RefPayed";
    import moment from 'moment';

    export default {
        name: 'Browse',

        data() {
            return {
                orders: [],
                failedOrders: [],
                payedOrders: [],
                currentTabIndex: 0,
                user: {ref_id: null},
                fromDate: null,
                toDate: null,
            }
        },

        mounted() {
            userApi.fetchProfile()
                .then(response => {
                    this.user = response;
                });
            userApi.fetchRefOrders()
                .then(async response => {
                    this.orders = response
                })
                .catch(error => {
                    let data = (error && error.response) ? error.response.data : {}
                    this.error = this.pretty(data)
                    this.loading = false
                })

            userApi.fetchRefPayed()
                .then(async response => {
                    this.payedOrders = response
                })
                .catch(error => {
                    let data = (error && error.response) ? error.response.data : {}
                    this.error = this.pretty(data)
                    this.loading = false
                })

            userApi.fetchRefFailed()
                .then(async response => {
                    this.failedOrders = response
                })
                .catch(error => {
                    let data = (error && error.response) ? error.response.data : {}
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },

        computed: {
            ordersFiltered() {
                return this.filterOrder(this.orders)
            },
            failedOrdersFiltered() {
                return this.filterOrder(this.failedOrders)
            },
            payedOrdersFiltered() {
                return this.filterOrder(this.payedOrders)
            },
        },

        methods: {
            filterOrder(orders) {
                if (!this.fromDate && !this.toDate) return orders
                let filtered = []
                orders.filter(item => {
                    if (this.fromDate && this.toDate) {
                        if (moment(item.crdate) >= this.fromDate && moment(item.crdate) <= this.toDate) filtered.push(item)
                    } else if (this.fromDate) {
                        if (moment(item.crdate) >= this.fromDate) filtered.push(item)
                    } else if (this.toDate) {
                        if (moment(item.crdate) <= this.toDate) filtered.push(item)
                    }
                })
                return filtered
            },

            setCurrentMonth() {
                this.fromDate = moment().startOf('month').startOf('day').toDate()
                this.toDate = null
            },

            setPrevMonth() {
                this.fromDate = moment().subtract(1, 'months').startOf('month').startOf('day').toDate()
                this.toDate = moment().subtract(1, 'months').endOf('month').endOf('day').toDate()
            },

            setPrev30days() {
                this.fromDate = moment().subtract(30, 'days').startOf('day').toDate()
                this.toDate = null
            },

            setAll() {
                this.fromDate = null
                this.toDate = null
            },
        },

        components: {RefPayed, RefFailed, RefOrders}
    }
</script>

<style>

    .profile-page-title .ref-order-tab {
        font-size: 25px;
    }

    .profile-page-title__count {
        color: #c0c0c0;
        font-size: 1rem;
    }

    .profile-page-title a {
        color: #0493c3;
        border-bottom: 1px solid;
    }

    .ref-order-tab {
        cursor: pointer;
        color: #0493c3;
        text-decoration: underline;
    }

    .ref-order-tab.active {
        color: #32325d;
        cursor: default;
        text-decoration: none;
    }


</style>
